"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMarkupFile = parseMarkupFile;
exports.checkBCFVersion = checkBCFVersion;
exports.parseBCFFile = parseBCFFile;
const jszip_1 = __importDefault(require("jszip"));
const xmlParser_1 = require("./xmlParser");
function parseMarkupFile(fileContent) {
    return __awaiter(this, void 0, void 0, function* () {
        // Use the existing parseXMLString function instead of xml2js
        return (0, xmlParser_1.parseXMLString)(fileContent);
    });
}
function checkBCFVersion(versionContent) {
    const versionRegex = /<VersionId>(\d+\.\d+)<\/VersionId>/;
    const match = versionContent.match(versionRegex);
    return match ? parseFloat(match[1]) >= 3.0 : false;
}
function parseBCFFile(file) {
    return __awaiter(this, void 0, void 0, function* () {
        console.log(`---start---`);
        const zip = new jszip_1.default();
        const zipContent = yield zip.loadAsync(file);
        // Parse version (but don't validate it)
        const versionFile = zipContent.file('bcf.version');
        let version;
        if (versionFile) {
            const versionXml = yield versionFile.async('string');
            version = parseVersion(versionXml);
        }
        else {
            // Provide default version if not found
            version = { VersionId: '3.0' };
        }
        // Parse project (optional)
        let project;
        const projectFile = zipContent.file('project.bcfp');
        if (projectFile) {
            const projectXml = yield projectFile.async('string');
            project = parseProject(projectXml);
        }
        // Parse extensions (optional)
        let extensions;
        const extensionsFile = zipContent.file('extensions.xml');
        if (extensionsFile) {
            const extensionsXml = yield extensionsFile.async('string');
            extensions = parseExtensions(extensionsXml);
        }
        // Parse topics
        const topics = [];
        // Find all GUID folders
        const guidFolders = Object.keys(zipContent.files)
            .filter(path => {
            const parts = path.split('/');
            return parts.length === 2 && parts[0].length > 0;
        })
            .map(path => path.split('/')[0])
            .filter((guid, index, array) => array.indexOf(guid) === index);
        console.log(guidFolders);
        for (const folderPath of guidFolders) {
            const topicId = folderPath.replace('/', '');
            const markupFile = zipContent.file(`${topicId}/markup.bcf`);
            if (markupFile) {
                console.log(`digging into markup file`);
                const markupXml = yield markupFile.async('string');
                const markup = (0, xmlParser_1.parseXMLString)(markupXml);
                // Find images in the topic folder - improved image detection
                const images = [];
                // Debug: Log all files in the topic folder
                const allTopicFiles = Object.keys(zipContent.files).filter(path => path.startsWith(`${topicId}/`) && !path.endsWith('/'));
                console.log(`Topic ${topicId} files:`, allTopicFiles);
                // Look for image files - more comprehensive search
                const imageFiles = Object.keys(zipContent.files).filter(path => {
                    const isInTopic = path.startsWith(`${topicId}/`);
                    const isNotDirectory = !path.endsWith('/');
                    const lowerPath = path.toLowerCase();
                    const isImage = lowerPath.endsWith('.png') ||
                        lowerPath.endsWith('.jpg') ||
                        lowerPath.endsWith('.jpeg') ||
                        lowerPath.endsWith('.gif') ||
                        lowerPath.endsWith('.bmp') ||
                        lowerPath.endsWith('.tiff') ||
                        lowerPath.endsWith('.tif');
                    return isInTopic && isNotDirectory && isImage;
                });
                console.log(`Found ${imageFiles.length} image files for topic ${topicId}:`, imageFiles);
                for (const imagePath of imageFiles) {
                    const imageFile = zipContent.file(imagePath);
                    if (imageFile) {
                        try {
                            const imageArrayBuffer = yield imageFile.async('arraybuffer');
                            console.log(`Processing image ${imagePath}, size: ${imageArrayBuffer.byteLength} bytes`);
                            // Determine MIME type from file extension
                            const extension = imagePath.toLowerCase().split('.').pop();
                            let mimeType = 'image/png'; // default
                            switch (extension) {
                                case 'jpg':
                                case 'jpeg':
                                    mimeType = 'image/jpeg';
                                    break;
                                case 'png':
                                    mimeType = 'image/png';
                                    break;
                                case 'gif':
                                    mimeType = 'image/gif';
                                    break;
                                case 'bmp':
                                    mimeType = 'image/bmp';
                                    break;
                            }
                            const imageBlob = new Blob([imageArrayBuffer], { type: mimeType });
                            const imageUrl = URL.createObjectURL(imageBlob);
                            images.push(imageUrl);
                            console.log(`Created blob URL for ${imagePath}: ${imageUrl}`);
                        }
                        catch (error) {
                            console.error(`Failed to process image ${imagePath}:`, error);
                        }
                    }
                    else {
                        console.warn(`Could not find file ${imagePath} in zip`);
                    }
                }
                console.log(`Total images processed for topic ${topicId}: ${images.length}`);
                topics.push({
                    markup,
                    images,
                    topicId
                });
            }
            else {
                console.log(`no markup.bcf found`);
            }
        }
        return {
            version,
            project,
            extensions,
            topics
        };
    });
}
function parseVersion(xml) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, 'text/xml');
    const versionElement = doc.querySelector('Version');
    return {
        VersionId: (versionElement === null || versionElement === void 0 ? void 0 : versionElement.getAttribute('VersionId')) || '',
    };
}
function parseProject(xml) {
    var _a;
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, 'text/xml');
    const projectElement = doc.querySelector('ProjectInfo Project');
    return {
        ProjectId: (projectElement === null || projectElement === void 0 ? void 0 : projectElement.getAttribute('ProjectId')) || '',
        Name: ((_a = projectElement === null || projectElement === void 0 ? void 0 : projectElement.querySelector('Name')) === null || _a === void 0 ? void 0 : _a.textContent) || undefined
    };
}
function parseExtensions(xml) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, 'text/xml');
    const getArrayFromElements = (selector) => {
        const elements = doc.querySelectorAll(selector);
        return Array.from(elements).map(el => el.textContent || '');
    };
    return {
        TopicType: getArrayFromElements('TopicType'),
        TopicStatus: getArrayFromElements('TopicStatus'),
        Priority: getArrayFromElements('Priority'),
        TopicLabel: getArrayFromElements('TopicLabel'),
        Stage: getArrayFromElements('Stage'),
        UserIdType: getArrayFromElements('UserIdType')
    };
}
function isValidGuid(str) {
    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return guidRegex.test(str);
}
